var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('label',{staticClass:"f-label"},[_vm._v(_vm._s(_vm.$t(_vm.label)))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }